/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import './styles.scss'
import { Link, Image } from '@ta-interaktiv/contentbricks'
import { members } from './members'
import './treeflex.css'

export function FamilyTree() {
  const imageContainer = React.useRef(null)

  React.useEffect(() => {
    const width = imageContainer.current.offsetWidth
    // console.log(width)
    imageContainer.current.scrollTo(
      Math.abs(imageContainer.current.scrollWidth - width) / 2,
      0
    )
    // .scroll(200)
  }, [imageContainer.current])
  //   console.log('Ausgabe', imageContainer)
  return (
    <div
      className='tf-tree tf-custom'
      style={{ fontSize: '10px' }}
      ref={imageContainer}
    >
      <ul className='tree'>
        <li className='stageOne'>
          {members
            .filter(f => f.stage === 1)
            .map((m, index) => (
              <div
                className='tf-nc column'
                // onClick={e => {
                //   this.handleClick(e, { index: m.id })
                // }}
              >
                <div className='persons'>{m.content}</div>
              </div>
            ))}
          <ul>
            {members
              .filter(f => f.stage === 2 && f.id === 2)
              .map((m, index) => (
                <li className='stageTwo'>
                  <div
                    className='tf-nc special'
                    // onClick={e => {
                    //   this.handleClick(e, { index: m.id })
                    // }}
                  >
                    <div className='persons' style={{paddingLeft: '120px'}}>{m.content}</div>
                    <div className='lineHorizontal' />

                    {members
                      .filter(f => f.stage === 2 && f.id === 4)
                      .map((m, index) => (
                        <>
                          <div className='persons'>{m.content}</div>
                        </>
                      ))}
                  </div>

                  <ul>
                    {members
                      .filter(f => (f.stage === 3) & (f.id === 4))
                      .map((m, index) => (
                        <li className='stageThree'>
                          <div
                            className='tf-nc'
                            // onClick={e => {
                            //   this.handleClick(e, { index: m.id })
                            // }}
                          >
                            <div className='persons'>{m.content}</div>
                          </div>
                          <ul className='column'>
                            {members
                              .filter(
                                f =>
                                  f.stage === 4 &&
                                  (f.id === 7 ||
                                    f.id === 8 ||
                                    f.id === 9 ||
                                    f.id === 10)
                              )
                              .map((m, index) => (
                                <li className='stageFour'>
                                  <div
                                    className='tf-nc'
                                    // onClick={e => {
                                    //   this.handleClick(e, {
                                    //     index: m.id
                                    //   })
                                    // }}
                                  >
                                    <div className='persons'>{m.content}</div>
                                    <div className='children'>{m.children}</div>
                                  </div>
                                </li>
                              ))}
                          </ul>
                        </li>
                      ))}
                    {members
                      .filter(f => (f.stage === 3) & (f.id === 5))
                      .map((m, index) => (
                        <li className='stageThree'>
                          <div
                            className='tf-nc'
                            // onClick={e => {
                            //   this.handleClick(e, { index: m.id })
                            // }}
                          >
                            <div className='persons'>{m.content}</div>
                          </div>
                        </li>
                      ))}
                    {members
                      .filter(f => (f.stage === 3) & (f.id === 6))
                      .map((m, index) => (
                        <li className='stageThree'>
                          <div
                            className='tf-nc'
                            // onClick={e => {
                            //   this.handleClick(e, { index: m.id })
                            // }}
                          >
                            <div className='persons'>{m.content}</div>
                          </div>
                          <ul className='column'>
                            {members
                              .filter(
                                f =>
                                  f.stage === 4 &&
                                  (f.id === 11 ||
                                    f.id === 12 ||
                                    f.id === 13 ||
                                    f.id === 14 ||
                                    f.id === 15)
                              )
                              .map((m, index) => (
                                <li className='stageFour'>
                                  <div
                                    className='tf-nc'
                                    // onClick={e => {
                                    //   this.handleClick(e, {
                                    //     index: m.id
                                    //   })
                                    // }}
                                  >
                                    <div className='persons'>{m.content}</div>
                                    <div className='children'>{m.children}</div>
                                  </div>
                                </li>
                              ))}
                          </ul>
                        </li>
                      ))}
                  </ul>
                </li>
              ))}
            {members
              .filter(f => f.stage === 2 && f.id === 3)
              .map((m, index) => (
                <li className='stageTwo'>
                  <div
                    className='tf-nc'
                    // onClick={e => {
                    //   this.handleClick(e, { index: m.id })
                    // }}
                  >
                    <div className='persons'>{m.content}</div>
                  </div>
                </li>
              ))}
          </ul>
        </li>
      </ul>
    </div>
  )
}
